import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import clsx from "clsx";
import { useStyles } from '../../assets/jss/Dashboard';
import CustomDonut from "../CustomComponents/CustomDonut/CustomDonut";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import ArrowUpIcon from "../../assets/images/arrowUp.png";
import ArrowDownIcon from "../../assets/images/arrowDown.png";
import ArrowForwardIcon from "../../assets/images/arrowRight.png";
import {CustomFiberManualRecordIcon} from "../CustomComponents/CustomIcon/CustomIcon";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import { getUserRBAC } from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function DashboardContentEngagementDial(props) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    // const theme = useTheme();
    const [getRBAC_CE_View] = React.useState(getUserRBAC(RBAC_CODE.CE_VIEW, props));
    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { engagementScore } = props;
    const [isApi, setIsApi] = React.useState();
    const [isApiFailed, setIsApiFailed] = React.useState();
    const [contentEngagementColors] = React.useState([
        "rgb(159,211,86)",
        "rgb(208,0,0)",
    ]);
    const [contentEngagementArray, setContentEngagementArray] = React.useState([]);
    React.useEffect(() => {
        setIsApi(props.isApi);
    }, [props.isApi]);
    React.useEffect(() => {
        setIsApiFailed(props.isApiFailed);
    }, [props.isApiFailed]);
    //console.log('classes : ',classes);
    React.useEffect(() => {
        if (engagementScore && engagementScore.currentScore !== undefined && engagementScore.currentScore !== null) {
            const engagementScoreValue = engagementScore.currentScore;
            const disengagementScoreValue = 100 - engagementScore.currentScore;
            setContentEngagementArray([
                {
                    quantity:
                        Math.round((engagementScoreValue + Number.EPSILON) * 100) / 100,
                    percentage: `${Math.round((engagementScoreValue + Number.EPSILON) * 100) / 100
                        }`,
                    name: t("ENGAGEMENT"),
                    id: 1,
                },
                {
                    quantity:
                        Math.round((disengagementScoreValue + Number.EPSILON) * 100) / 100,
                    percentage: `${Math.round((disengagementScoreValue + Number.EPSILON) * 100) / 100
                        }`,
                    name: t("DISENGAGEMENT"),
                    id: 2,
                },
            ]);
        }
    }, [engagementScore]);

    return (
        <CustomPaper square elevation={0} className={classes.height100}>
            <CustomCard
                elevation={0}
                className={clsx(classes.height100, classes.cardContentWrapper)}
            >
                <CustomCardContent className={classes.cardContent}>
                    <CustomTypography
                        className={classes.cardTitle}
                        component="h3"
                        variant="h3"
                    >
                        {t("CONTENT_ENGAGEMENT")}
                    </CustomTypography>
                    <CustomGrid
                        container
                        className={classes.graphContainer}
                        justifyContent="center"
                        spacing={5}
                    >
                        <CustomGrid item>
                            {contentEngagementArray && contentEngagementArray.length ? (
                                <CustomDonut
                                    data={contentEngagementArray}
                                    colors={contentEngagementColors}
                                    width={300}
                                    height={300}
                                    legendLabel={false}
                                    externalRadius={130}
                                    internalRadius={100}
                                />
                            ) : !isApi ? (
                                <CustomDonut
                                    data={[]}
                                    width={300}
                                    height={300}
                                    legendLabel={false}
                                    externalRadius={130}
                                    internalRadius={100}
                                />
                            ) : (
                                <CustomCircularProgress />
                            )}
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid
                        container
                        justifyContent="space-around"
                        spacing={5}
                        className={classes.trendingScoreList}
                    >
                        <CustomGrid item>
                            <div>
                                <CustomTypography
                                    className={classes.scoreValue}
                                    component="h4"
                                    variant="h4"
                                >
                                    {engagementScore && engagementScore.scoreTrend === -1 ? (
                                        <img
                                            alt=""
                                            src={ArrowDownIcon}
                                            className={classes.arrowDownIcon}
                                        />
                                    ) : engagementScore && engagementScore.scoreTrend === 1 ? (
                                        <img
                                            alt=""
                                            src={ArrowUpIcon}
                                            className={classes.arrowUpIcon}
                                        />
                                    ) : engagementScore && engagementScore.scoreTrend === 0 ? (
                                        <img
                                            alt=""
                                            src={ArrowForwardIcon}
                                            className={classes.arrowForwardIcon}
                                        />
                                    ) : null}
                                    {isApi || !engagementScore ? (
                                        <CustomSkeleton
                                            className={classes.scoreValueSkeleton}
                                            animation="wave"
                                            width={60}
                                            height={24}
                                        />
                                    ) : engagementScore ? engagementScore.score !== undefined && engagementScore.score !== null ? (
                                        `${Math.round(
                                            (engagementScore.score + Number.EPSILON) * 100
                                        ) / 100
                                        }%`
                                    ) : "N/A" : (
                                        "0"
                                    )}
                                </CustomTypography>
                                <CustomTypography
                                    className={classes.scoreLabel}
                                    component="span"
                                >
                                    <CustomFiberManualRecordIcon
                                        className={clsx(
                                            !isApi &&
                                            !isApiFailed &&
                                            engagementScore &&
                                            classes.colorSuccess,
                                            classes.scoreLabelCircle
                                        )}
                                    />{" "}
                                    {t("ENGAGEMENT")}
                                </CustomTypography>
                            </div>
                        </CustomGrid>
                        <CustomGrid item>
                            <div>
                                <CustomTypography
                                    className={classes.scoreValue}
                                    component="h4"
                                    variant="h4"
                                >
                                    {isApi || !engagementScore ? (
                                        <CustomSkeleton
                                            className={classes.scoreValueSkeleton}
                                            animation="wave"
                                            width={60}
                                            height={24}
                                        />
                                    ) : engagementScore ? engagementScore.score !== undefined && engagementScore.score !== null ? (
                                        `${100 -
                                        Math.round(
                                            (engagementScore.score + Number.EPSILON) * 100
                                        ) /
                                        100
                                        }%`
                                    ) : "N/A" : (
                                        "0"
                                    )}
                                </CustomTypography>
                                <CustomTypography
                                    className={classes.scoreLabel}
                                    component="span"
                                >
                                    <CustomFiberManualRecordIcon
                                        className={clsx(
                                            !isApi &&
                                            !isApiFailed &&
                                            engagementScore &&
                                            classes.colorError,
                                            classes.scoreLabelCircle
                                        )}
                                    />{" "}
                                    {t("DISENGAGEMENT")}
                                </CustomTypography>
                            </div>
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid
                        container
                        justifyContent={"flex-end"}
                        className={classes.justifyCenter}
                        spacing={0}
                    >
                        <CustomGrid item>
                            <CustomBox component="div" mt={2}>
                                {getRBAC_CE_View &&
                                    getRBAC_CE_View.isAccessible === EntityAccess.ALLOWED ? (
                                    <>
                                        {isApi || isApiFailed || !engagementScore ? (
                                            <CustomTypography
                                                className={classes.viewDetailLinkDisabled}
                                                component="span"
                                            >
                                                {t("VIEW_DETAILS")}
                                            </CustomTypography>
                                        ) : (
                                            <CustomLink
                                                className={classes.viewDetailLink}
                                                href={params.impersonationid ? `/impersonation/${params.impersonationid}/engagement` : "/engagement"}
                                            >
                                                {t("VIEW_DETAILS")}
                                            </CustomLink>
                                        )}
                                    </>
                                ) : null}
                            </CustomBox>
                        </CustomGrid>
                    </CustomGrid>
                </CustomCardContent>
            </CustomCard>
        </CustomPaper>
    );
}
